/**
 * Generated from ch4_p05.fla
 */
export function ch4_p05(this: Ich4_p05) {
	const stickerButton = this.stickerButton;
	if (!stickerButton[0] && stickerButton.elementFactory) {
		stickerButton[0] = stickerButton.elementFactory(0,undefined);
	}
	if (stickerButton[0]) {
		ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1.call(stickerButton[0] as Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1);
		stickerButton[0].x = 625;
		stickerButton[0].y = 669.25;
		stickerButton[0].width = 140.00;
		stickerButton[0].height = 134.50;
		stickerButton[0].alpha = 1;
		if (stickerButton[0].onLayout) stickerButton[0].onLayout();
	}
	if (!stickerButton[1] && stickerButton.elementFactory) {
		stickerButton[1] = stickerButton.elementFactory(1,undefined);
	}
	if (stickerButton[1]) {
		ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2.call(stickerButton[1] as Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2);
		stickerButton[1].x = 770.5;
		stickerButton[1].y = 680;
		stickerButton[1].width = 77.00;
		stickerButton[1].height = 113.00;
		stickerButton[1].alpha = 1;
		if (stickerButton[1].onLayout) stickerButton[1].onLayout();
	}
	if (!stickerButton[2] && stickerButton.elementFactory) {
		stickerButton[2] = stickerButton.elementFactory(2,undefined);
	}
	if (stickerButton[2]) {
		ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3.call(stickerButton[2] as Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3);
		stickerButton[2].x = 916.75;
		stickerButton[2].y = 658.5;
		stickerButton[2].width = 73.50;
		stickerButton[2].height = 164.00;
		stickerButton[2].alpha = 1;
		if (stickerButton[2].onLayout) stickerButton[2].onLayout();
	}
	if (!stickerButton[3] && stickerButton.elementFactory) {
		stickerButton[3] = stickerButton.elementFactory(3,undefined);
	}
	if (stickerButton[3]) {
		ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4.call(stickerButton[3] as Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4);
		stickerButton[3].x = 1078.5;
		stickerButton[3].y = 675.75;
		stickerButton[3].width = 107.00;
		stickerButton[3].height = 120.50;
		stickerButton[3].alpha = 1;
		if (stickerButton[3].onLayout) stickerButton[3].onLayout();
	}
	const bg = this.bg;
	ch4_p05_hh_ch4_p05psdAssetchp4_p05_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const bookBottom = this.bookBottom;
	ch4_p05_hh_ch4_p05psdAssetbookchp4_p05_bookbottom.call(this.bookBottom);
	bookBottom.x = 835.5;
	bookBottom.y = 343;
	bookBottom.width = 1180.00;
	bookBottom.height = 661.00;
	bookBottom.alpha = 1.00;
	if (bookBottom.onLayout) bookBottom.onLayout();
	const section3bg = this.section3bg;
	ch4_p05_hh_ch4_p05psdAsset3booksection3.call(this.section3bg);
	section3bg.x = 530.25;
	section3bg.y = 480.5;
	section3bg.width = 580.50;
	section3bg.height = 381.00;
	section3bg.alpha = 1.00;
	if (section3bg.onLayout) section3bg.onLayout();
	const section1bg = this.section1bg;
	ch4_p05_hh_ch4_p05psdAsset3booksection1.call(this.section1bg);
	section1bg.x = 552.25;
	section1bg.y = 178.75;
	section1bg.width = 632.50;
	section1bg.height = 406.50;
	section1bg.alpha = 1.00;
	if (section1bg.onLayout) section1bg.onLayout();
	const section4bg = this.section4bg;
	ch4_p05_hh_ch4_p05psdAsset3booksection4.call(this.section4bg);
	section4bg.x = 1137;
	section4bg.y = 454;
	section4bg.width = 587.00;
	section4bg.height = 395.00;
	section4bg.alpha = 1.00;
	if (section4bg.onLayout) section4bg.onLayout();
	const section2bg = this.section2bg;
	ch4_p05_hh_ch4_p05psdAsset3booksection2.call(this.section2bg);
	section2bg.x = 1104.25;
	section2bg.y = 151.5;
	section2bg.width = 514.50;
	section2bg.height = 326.00;
	section2bg.alpha = 1.00;
	if (section2bg.onLayout) section2bg.onLayout();
	const stickerMask = this.stickerMask;
	ch4_p05_stickerMask.call(this.stickerMask);
	stickerMask.x = 836;
	stickerMask.y = 332.25;
	stickerMask.width = 1180.00;
	stickerMask.height = 638.50;
	stickerMask.alpha = 1.00;
	if (stickerMask.onLayout) stickerMask.onLayout();
	const bookTop = this.bookTop;
	ch4_p05_hh_ch4_p05psdAssetbookchp4_p05_booktop.call(this.bookTop);
	bookTop.x = 835.5;
	bookTop.y = 331.75;
	bookTop.width = 1180.00;
	bookTop.height = 638.50;
	bookTop.alpha = 1.00;
	if (bookTop.onLayout) bookTop.onLayout();
	const photoSmallPiper = this.photoSmallPiper;
	ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotospiper.call(this.photoSmallPiper);
	photoSmallPiper.x = 526.25;
	photoSmallPiper.y = 165.5;
	photoSmallPiper.width = 380.50;
	photoSmallPiper.height = 264.00;
	photoSmallPiper.alpha = 1.00;
	if (photoSmallPiper.onLayout) photoSmallPiper.onLayout();
	const photoSmallAmy = this.photoSmallAmy;
	ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosamys.call(this.photoSmallAmy);
	photoSmallAmy.x = 1111;
	photoSmallAmy.y = 448.25;
	photoSmallAmy.width = 436.00;
	photoSmallAmy.height = 320.50;
	photoSmallAmy.alpha = 1.00;
	if (photoSmallAmy.onLayout) photoSmallAmy.onLayout();
	const photoSmallTyler = this.photoSmallTyler;
	ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotostylers.call(this.photoSmallTyler);
	photoSmallTyler.x = 560.75;
	photoSmallTyler.y = 442.25;
	photoSmallTyler.width = 445.50;
	photoSmallTyler.height = 318.50;
	photoSmallTyler.alpha = 1.00;
	if (photoSmallTyler.onLayout) photoSmallTyler.onLayout();
	const photoSmallOscar = this.photoSmallOscar;
	ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosOscars.call(this.photoSmallOscar);
	photoSmallOscar.x = 1091.25;
	photoSmallOscar.y = 183.5;
	photoSmallOscar.width = 434.50;
	photoSmallOscar.height = 297.00;
	photoSmallOscar.alpha = 1.00;
	if (photoSmallOscar.onLayout) photoSmallOscar.onLayout();
	const frameRight = this.frameRight;
	ch4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const arrowButton = this.arrowButton;
	ch4_p05_hh_ch4_p05psdAssetchp4_p05_arrow.call(this.arrowButton);
	arrowButton.x = 1397;
	arrowButton.y = 686.5;
	arrowButton.width = 141.00;
	arrowButton.height = 140.00;
	arrowButton.alpha = 1.00;
	if (arrowButton.onLayout) arrowButton.onLayout();
	const darkOverlay = this.darkOverlay;
	ch4_p05_hh_ch4_p05psdAsset2EnlargedPhotoschp4_p05_darkoverlay.call(this.darkOverlay);
	darkOverlay.x = 832;
	darkOverlay.y = 384;
	darkOverlay.width = 1664.00;
	darkOverlay.height = 768.00;
	darkOverlay.alpha = 1.00;
	if (darkOverlay.onLayout) darkOverlay.onLayout();
	const photoLargeTyler = this.photoLargeTyler;
	ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_tyler.call(this.photoLargeTyler);
	photoLargeTyler.x = 822.25;
	photoLargeTyler.y = 376;
	photoLargeTyler.width = 857.50;
	photoLargeTyler.height = 572.00;
	photoLargeTyler.alpha = 1.00;
	if (photoLargeTyler.onLayout) photoLargeTyler.onLayout();
	const photoLargePiper = this.photoLargePiper;
	ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_piper.call(this.photoLargePiper);
	photoLargePiper.x = 822.25;
	photoLargePiper.y = 376;
	photoLargePiper.width = 857.50;
	photoLargePiper.height = 572.00;
	photoLargePiper.alpha = 1.00;
	if (photoLargePiper.onLayout) photoLargePiper.onLayout();
	const photoLargeAmy = this.photoLargeAmy;
	ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_amy.call(this.photoLargeAmy);
	photoLargeAmy.x = 822.25;
	photoLargeAmy.y = 376;
	photoLargeAmy.width = 857.50;
	photoLargeAmy.height = 572.00;
	photoLargeAmy.alpha = 1.00;
	if (photoLargeAmy.onLayout) photoLargeAmy.onLayout();
	const photoLargeOscar = this.photoLargeOscar;
	ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_oscar.call(this.photoLargeOscar);
	photoLargeOscar.x = 822.25;
	photoLargeOscar.y = 376;
	photoLargeOscar.width = 857.50;
	photoLargeOscar.height = 572.00;
	photoLargeOscar.alpha = 1.00;
	if (photoLargeOscar.onLayout) photoLargeOscar.onLayout();
	const whiteBorder = this.whiteBorder;
	ch4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_whiteborder.call(this.whiteBorder);
	whiteBorder.x = 822;
	whiteBorder.y = 376;
	whiteBorder.width = 901.00;
	whiteBorder.height = 615.00;
	whiteBorder.alpha = 1.00;
	if (whiteBorder.onLayout) whiteBorder.onLayout();
	const buttonClose = this.buttonClose;
	ch4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_close.call(this.buttonClose);
	buttonClose.x = 1259.25;
	buttonClose.y = 89;
	buttonClose.width = 90.50;
	buttonClose.height = 91.00;
	buttonClose.alpha = 1.00;
	if (buttonClose.onLayout) buttonClose.onLayout();
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetchp4_p05_bg(this: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetbookchp4_p05_bookbottom(this: Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_bookbottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_bookbottom", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset3booksection3(this: Ich4_p05_hh_ch4_p05psdAsset3booksection3) {
	if (this.setLayoutTexture) this.setLayoutTexture("section3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset3booksection1(this: Ich4_p05_hh_ch4_p05psdAsset3booksection1) {
	if (this.setLayoutTexture) this.setLayoutTexture("section1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset3booksection4(this: Ich4_p05_hh_ch4_p05psdAsset3booksection4) {
	if (this.setLayoutTexture) this.setLayoutTexture("section4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset3booksection2(this: Ich4_p05_hh_ch4_p05psdAsset3booksection2) {
	if (this.setLayoutTexture) this.setLayoutTexture("section2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_stickerMask(this: Ich4_p05_stickerMask) {
	if (this.setLayoutTexture) this.setLayoutTexture("stickerMask.png", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetbookchp4_p05_booktop(this: Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_booktop) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_booktop", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotospiper(this: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotospiper) {
	if (this.setLayoutTexture) this.setLayoutTexture("piper", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosamys(this: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosamys) {
	if (this.setLayoutTexture) this.setLayoutTexture("amys", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotostylers(this: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotostylers) {
	if (this.setLayoutTexture) this.setLayoutTexture("tylers", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosOscars(this: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosOscars) {
	if (this.setLayoutTexture) this.setLayoutTexture("Oscars", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeR(this: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeL(this: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1(this: Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_sticker1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2(this: Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_sticker2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3(this: Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_sticker3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4(this: Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_sticker4", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetchp4_p05_arrow(this: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_arrow) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_arrow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset2EnlargedPhotoschp4_p05_darkoverlay(this: Ich4_p05_hh_ch4_p05psdAsset2EnlargedPhotoschp4_p05_darkoverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_darkoverlay", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_tyler(this: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_tyler", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_piper(this: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_piper) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_piper", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_amy(this: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_amy) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_amy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_oscar(this: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_oscar", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_whiteborder(this: Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_whiteborder) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_whiteborder", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_close(this: Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_close) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p05_close", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich4_p05Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p05Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p05Sprite extends Ich4_p05Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p05Text extends Ich4_p05Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p05Polygon extends Array<number> {
}
interface Ich4_p05 {
	readonly stickerButton: Ich4_p05Array<Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1|Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2|Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3|Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4>;
	readonly bg: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_bg;
	readonly bookBottom: Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_bookbottom;
	readonly section3bg: Ich4_p05_hh_ch4_p05psdAsset3booksection3;
	readonly section1bg: Ich4_p05_hh_ch4_p05psdAsset3booksection1;
	readonly section4bg: Ich4_p05_hh_ch4_p05psdAsset3booksection4;
	readonly section2bg: Ich4_p05_hh_ch4_p05psdAsset3booksection2;
	readonly stickerMask: Ich4_p05_stickerMask;
	readonly bookTop: Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_booktop;
	readonly photoSmallPiper: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotospiper;
	readonly photoSmallAmy: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosamys;
	readonly photoSmallTyler: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotostylers;
	readonly photoSmallOscar: Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosOscars;
	readonly frameRight: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeR;
	readonly frameLeft: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeL;
	readonly arrowButton: Ich4_p05_hh_ch4_p05psdAssetchp4_p05_arrow;
	readonly darkOverlay: Ich4_p05_hh_ch4_p05psdAsset2EnlargedPhotoschp4_p05_darkoverlay;
	readonly photoLargeTyler: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_tyler;
	readonly photoLargePiper: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_piper;
	readonly photoLargeAmy: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_amy;
	readonly photoLargeOscar: Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_oscar;
	readonly whiteBorder: Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_whiteborder;
	readonly buttonClose: Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_close;
}
interface Ich4_p05_hh_ch4_p05psdAssetchp4_p05_bg extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_bookbottom extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset3booksection3 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset3booksection1 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset3booksection4 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset3booksection2 extends Ich4_p05Sprite {
}
interface Ich4_p05_stickerMask extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetbookchp4_p05_booktop extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotospiper extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosamys extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotostylers extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetFPOscaleddownphotosOscars extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeR extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetchp4_p05_wcframeL extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker1 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker2 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker3 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetStickerButtonschp4_p05_sticker4 extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetchp4_p05_arrow extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset2EnlargedPhotoschp4_p05_darkoverlay extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_tyler extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_piper extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_amy extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAsset1EnlargedPhotosFullsizePhotoschp4_p05_oscar extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_whiteborder extends Ich4_p05Sprite {
}
interface Ich4_p05_hh_ch4_p05psdAssetEnlargedPhotoschp4_p05_close extends Ich4_p05Sprite {
}
